var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TrackCodes',{attrs:{"progressCode":[120, 130, 140, 150, 170],"isPaid":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }